import { AWARDS } from "@/constants";

export function getAwardByCode(code) {
  return AWARDS.find(award => award.code === code);
}

export function getAwardsByCode(codes) {
  return codes.map(code => getAwardByCode(code)).filter(Boolean);
}